export default {
  metaInfo() {
    return {
      titleTemplate: this.$t("Meta.tail"),
      ...this.metaInfo,
    };
  },
  data() {
    return {
      customMeta: undefined,
      customTitle: undefined,
    };
  },
  computed: {
    metaInfo() {
      return this.getMetaObj(this.$route.meta.metaInfo);
    },
  },
  mounted() {
    this.$debug(
      "Настройка мета инфы для страницы: " + this.$route.path,
      "accent",
      this.metaInfo
    );
  },
  methods: {
    getMetaObj(prop) {
      const key = "Meta." + (prop || "default");

      const meta = {
        title:
          this.customTitle ||
          (prop === "custom"
            ? this.customMeta?.title || this.$t("Meta.default.title")
            : this.$t(key + ".title")),
        desc:
          prop === "custom"
            ? this.customMeta?.desc || this.$t("Meta.default.desc")
            : this.$t(key + ".desc"),
      };
      return {
        title: meta.title,
        meta: [
          {
            property: "og:title",
            content: meta.title + this.$t("Meta.tail2"),
          },
          {
            property: "description",
            content: meta.desc,
          },
          {
            property: "og:description",
            content: meta.desc,
          },
          {
            property: "og:url",
            content: window.location.href,
          },
        ],
      };
    },
  },
};
